import { createSlice } from '@reduxjs/toolkit';
const SLICE_NAME = 'currency';

export const currencyRatesSlice = createSlice({
    name: SLICE_NAME,
    initialState: {
        rates: {},
        isLoading: false,
    },
    reducers: {
        setCurrencyRates: (state, action) => {
            state.rates = action.payload;
        },
    },
});

export const { setCurrencyRates } = currencyRatesSlice.actions;

export const currencyRatesSelector = (state) =>
    state.commonData.currencyRates.rates;

export const currencyRatesLoadingSelector = (state) =>
    state.commonData.currencyRates.isLoading;
export const currencyRates = currencyRatesSlice.reducer;
